import React, { useState, useEffect } from 'react';
import map from 'lodash.map';
import classnames from 'classnames';
import values from 'object.values';
import isEmpty from 'lodash.isempty';
import { path } from 'utils';
import sortObject from 'sort-object-keys';

import SearchIcon from 'assets/icons/search-icon.svg';
import Checkbox from 'components/libs/Checkbox';
import Input from 'components/libs/Input';
// import ButtonBottomFixed from 'components/libs/Buttons/ButtonBottomFixed';
import ArrowIcon from 'assets/icons/arrow-back-blk.svg';
import {
  BrowserView,
  isBrowser,
  isMobile,
  MobileView
} from 'react-device-detect';
import CloseIcon from 'assets/icons/close-popup.svg';
import { CURRENT_LANG_PREFIX } from 'constants/index';
import { translate } from '../../../../constants/language';

// const buttonText = {
//   province: translate('Continue'),
//   city: translate('Continue'),
//   area: translate('Confirm')
// };

export default ({
  provinces,
  closeProvinceModal,
  selectProvince,
  selectedProvinces = '',
  onNext,
  onBack,
  type,
  title,
  isSla = false
}) => {
  const [filterValue, setFilterValue] = useState({});
  const onFilterChange = event => {
    setFilterValue({ ...filterValue, [type]: event.target.value || '' });
  };
  const onSelectProvince = ({ id, name }) => {
    selectProvince({ id, name }, type);
    onNext();
  };
  let sectionCounter = 0;

  const getFilteredResult = ({ list }) => {
    const listByAlphabets = [];
    let counter = 1;

    map(list, ({ name, id: itemId }, id) => {
      if (
        name.toLowerCase().indexOf((filterValue[type] || '').toLowerCase()) >
          -1 ||
        !filterValue[type]
      ) {
        listByAlphabets.push(
          <div
            onClick={() => onSelectProvince({ id: isSla ? itemId : id, name })}
            onKeyPress={() =>
              onSelectProvince({ id: isSla ? itemId : id, name })
            }
            className={`flex type-${type}`}
            role="button"
            id={`${type}-${counter}`}
          >
            <Checkbox
              isSolid={true}
              className="v-m"
              checked={path([type, 'name'], selectedProvinces) === name}
            />
            <span className="pl-16 pr-16 v-m lh-24">{name}</span>
          </div>
        );
        counter += 1;
      }
    });
    return listByAlphabets;
  };

  let listMap;
  let emptyArea = false;
  function getCity() {
    return path(
      [
        selectedProvinces.province.name.charAt(0),
        selectedProvinces.province.id,
        'citiesAlphabetical'
      ],
      provinces
    );
  }
  if (type === 'province') {
    listMap = provinces;
  } else if (type === 'city') {
    listMap = getCity();
    if (isEmpty(listMap)) {
      listMap = {
        [selectedProvinces.province.name.charAt(0)]: {
          [selectedProvinces.province.id]: {
            id: selectedProvinces.province.id,
            name: selectedProvinces.province.name
          }
        }
      };
    }
  } else if (type === 'area') {
    listMap = path(
      [
        selectedProvinces.province.name.charAt(0),
        selectedProvinces.province.id,
        'citiesAlphabetical',
        selectedProvinces.city.name.charAt(0),
        selectedProvinces.city.name,
        'areas'
      ],
      provinces
    );
    if (isEmpty(listMap)) {
      emptyArea = {
        id: selectedProvinces.city.id,
        name: selectedProvinces.city.name
      };
      listMap = {
        [selectedProvinces.city.name.charAt(0)]: {
          [selectedProvinces.city.name]: emptyArea
        }
      };
    }
  }
  useEffect(() => {
    if (type === 'area') {
      let flat = values(listMap);
      if (flat.length === 1) {
        flat = values(flat[0]);
        if (flat.length === 1) {
          onSelectProvince(flat[0]);
        }
      }
    }
  }, [type]);
  const sortedListMap = listMap && sortObject(listMap);
  return (
    <div className={classnames({ 'pl-25 pr-25': isMobile })}>
      <div
        className={classnames(
          'flex middle-xs between-xs bb-light-gray pb-16 bg-white',
          isBrowser ? 'pt-4 mb-16' : 'pt-16 mb-10'
        )}
      >
        <div className="fs-18 fw-6 c-dark-gray">
          {translate('Select your')}&nbsp;{title}
        </div>
        <div>
          <a
            onClick={closeProvinceModal}
            onKeyPress={closeProvinceModal}
            role="link"
            className="c-pastel-red fs-10 fw-5 cap cancel-popup"
          >
            <MobileView>{translate('Cancel')}</MobileView>
            <BrowserView>
              <CloseIcon className="d-block" />
            </BrowserView>
          </a>
        </div>
      </div>

      <div>
        <div className="mb-10 flex middle-xs">
          <If condition={type === 'city' || type === 'area'}>
            <div
              className="fs-12 fw-5 c-dark-gray pb-3 mr-3 mx-w-30p flex middle-xs choose-province"
              onClick={() => onBack('province')}
              onKeyPress={() => onBack('province')}
              role="button"
            >
              <div className="txt-overflow-ellipsis">
                {selectedProvinces.province.name || ''}
              </div>
              <div className="rtl-flip">
                <ArrowIcon
                  className="rot-180 ml-7 mr-7"
                  height="10"
                  width="7"
                />
              </div>
            </div>
          </If>
          <If condition={type === 'area'}>
            <div
              className={classnames(
                'fs-12 fw-5 c-dark-gray pb-3 mr-5 mx-w-30p flex middle-xs ',
                `choose-city`
              )}
              onClick={() => onBack('city')}
              onKeyPress={() => onBack('city')}
              role="button"
            >
              <div className="txt-overflow-ellipsis">
                {selectedProvinces.city.name || ''}
              </div>
              <div className="rtl-flip">
                <ArrowIcon
                  className="rot-180 ml-7 mr-7"
                  height="10"
                  width="7"
                />
              </div>
            </div>
          </If>
          <div
            className={classnames(
              'fs-12 fw-5 c-dark-gray pb-3 bb-brand  txt-overflow-ellipsis',
              `choose-${type}`
            )}
          >
            {translate('Choose')}&nbsp;{title}
          </div>
        </div>
        <Input
          className={classnames(
            'h-40 b-light-gray bg-white-three mb-16',
            CURRENT_LANG_PREFIX === 'en' ? 'pl-40' : 'pr-40'
          )}
          name={type}
          value={filterValue[type] || ''}
          onChange={onFilterChange}
          autocomplete="style-off"
          placeholder={`${translate('Search for Your')} ${title}`}
          prefix={
            <SearchIcon
              height="15px"
              className="d-block pos-abs"
              style={{
                top: 12,
                left: CURRENT_LANG_PREFIX === 'en' ? 16 : 'auto',
                right: CURRENT_LANG_PREFIX === 'ar' ? 16 : 'auto'
              }}
            />
          }
        />

        <div
          className="mb-16 overflow-auto h-60vh"
          style={{ height: isBrowser ? 'calc(100vh - 220px)' : '60vh' }}
        >
          <If condition={sortedListMap}>
            {map(sortedListMap, (list, alphabet) => {
              const result = getFilteredResult({ list, alphabet });

              if (result.length) {
                sectionCounter += 1;
                return (
                  <div className="mt-10" id={`section-${sectionCounter}`}>
                    <div className="flex middle-xs mb-16">
                      <div className="fs-14 fw-6 c-dark-gray">{alphabet}</div>
                      <div className="w-10 h-15" />
                      <hr className="m-0 w100p bg-very-light-pink-gray" />
                    </div>
                    {result.map(r => (
                      <div className="fs-14 c-dark-gray mb-16" key={r}>
                        {r}
                      </div>
                    ))}
                  </div>
                );
              }
              return null;
            })}
          </If>
        </div>
      </div>
      {/* <ButtonBottomFixed
        className="primary"
        onClick={onNext}
        disabled={!isSelected}
        loadingOnDisabled={false}
      >
        {buttonText[type]}
      </ButtonBottomFixed> */}
    </div>
  );
};
